module.exports = __webpack_public_path__ + "img/27.8a95794f.png";